
import axios from 'axios';

const API_ENDPOINT = 'https://world.openfoodfacts.org/api/v0/product/';

export async function fetchProductData(barcode) {
  try {
    const response = await axios.get(`${API_ENDPOINT}${barcode}.json`);
    if (response.data && response.data.product) {
      console.log('Produktdata modtaget:', JSON.stringify(response.data.product, null, 2));
      return response.data.product;
    } else {
      throw new Error('Produktdata ikke fundet');
    }
  } catch (error) {
    console.error('Fejl ved hentning af produktdata:', error.message);
    throw error;
  }
}

export function extractData(product, allergens) {
  console.log('Produkt før dataudtræk:', JSON.stringify(product, null, 2));
  
  const ingredientsFields = [
    'ingredients_text_da',
    'ingredients_text_en',
    'ingredients_text',
    'ingredients_text_with_allergens'
  ];

  const ingredientsList = ingredientsFields
    .map(field => product[field] || '')
    .filter(text => typeof text === 'string' && text.trim() !== '')
    .join(' ');

  const categories = Array.isArray(product.categories_tags) && product.categories_tags.length
    ? product.categories_tags.join(', ')
    : 'Ingen kategoridata fundet';

  const productName = typeof product.product_name === 'string' && product.product_name.trim() !== ''
    ? product.product_name
    : 'Ukendt produkt';

  const foundAllergens = allergens.filter(allergen =>
    ingredientsList.toLowerCase().includes(allergen.toLowerCase())
  );

  console.log('Uddraget data:', {
    productName,
    ingredientsList,
    categories,
    foundAllergens
  });

  return {
    productName,
    ingredientsList,
    categories,
    foundAllergens
  };
}
